import _crc32Stream from "./crc32-stream";
import _deflateCrc32Stream from "./deflate-crc32-stream";
var exports = {};
exports = {
  CRC32Stream: _crc32Stream,
  DeflateCRC32Stream: _deflateCrc32Stream
};
export default exports;
export const CRC32Stream = exports.CRC32Stream;